/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

export type AdminMatchDashboardGigsGrantedProsRetrieveOrdering = typeof AdminMatchDashboardGigsGrantedProsRetrieveOrdering[keyof typeof AdminMatchDashboardGigsGrantedProsRetrieveOrdering];


export const AdminMatchDashboardGigsGrantedProsRetrieveOrdering = {
  avg_rating: 'avg_rating',
  completion_percentage: 'completion_percentage',
  distance: 'distance',
  match_score: 'match_score',
} as const;
